var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 109,
    viewBox: "0 0 151 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11485_49982)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11485_49982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.722 108.78C143.302 101.683 149.833 88.9206 149.82 74.389C149.796 51.2479 133.174 42.1918 114.923 45.8669C111.797 46.4935 108.248 46.5062 105.398 45.0835C103.004 43.8894 101.256 41.5182 101.569 39.1132C101.892 36.6742 104.179 34.7519 106.698 33.6848C116.126 29.6985 118.992 22.9487 114.923 13.1824C107.146 -0.532425 84.6467 -0.462033 70.1762 2.01926C51.8323 5.16484 39.752 25.9892 43.4081 44.8295C44.0293 48.0348 45.5461 51.0962 43.4081 54.0983C40.018 58.8619 32.7659 60.581 26.708 60.3142C18.4495 59.9543 10.1428 63.3502 5.1395 69.1385C-1.39788 76.7016 -1.57689 97.0988 17.9198 108.78C17.9246 108.78 136.036 108.78 126.722 108.78Z",
    fill: "url(#paint0_linear_11485_49982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.118 108.779H11.5026C11.4512 108.779 11.4067 108.745 11.4067 108.703C11.4067 108.661 11.4512 108.626 11.5026 108.626H139.118C139.17 108.626 139.214 108.661 139.214 108.703C139.214 108.745 139.173 108.779 139.118 108.779Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M102.985 103.127L106.234 68.3643H64.8257V108.78H98.9529C102.615 108.78 102.759 105.177 102.985 103.127Z",
    fill: "#C4132B"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11485_49982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.4082 100.071L28.1709 99.8057L28.5489 16.8291L76.7458 17.0402L86.7345 28.0256L86.4082 100.071Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3117 28.188L85.988 99.6473L28.5949 99.3856L28.969 17.253L76.5584 17.4614L86.3117 28.188Z",
    stroke: "white",
    strokeWidth: 0.844079
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.9322 108.779L26.5338 108.779C24.0966 108.779 22.101 106.955 21.8546 104.506L18.2878 68.6837C18.2057 67.8498 18.8047 67.1723 19.6262 67.1723L64.7536 67.1723C65.25 67.1723 65.6915 66.9187 65.9243 66.4983L67.16 64.2781C67.3928 63.8576 67.8343 63.604 68.3307 63.604H89.4676C90.2891 63.604 91.0217 64.2815 91.1072 65.1154L94.8965 103.126C95.1224 105.176 95.2662 108.779 98.9322 108.779Z",
    fill: "#EE0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.578 108.78H98.8684C96.1985 108.78 95.3975 106.869 95.0723 105.041H21.9878C22.4465 107.216 24.3223 108.78 26.578 108.78Z",
    fill: "#C4132B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.051 25.5148C97.6415 18.0254 86.3434 17.274 78.8115 23.8294C71.2796 30.3849 70.3744 41.7734 76.7808 49.2636C82.7828 56.2754 93.0683 57.3814 100.535 52.1121L103.652 55.7518L106.492 53.2794L103.375 49.6396C109.637 42.9542 110.053 32.5265 104.051 25.5148ZM100.011 48.5996C93.7845 54.0236 84.444 53.4 79.1432 47.2077C73.8424 41.0153 74.5939 31.6029 80.8207 26.1788C87.0475 20.7548 96.388 21.3784 101.689 27.5707C106.99 33.7631 106.239 43.1789 100.011 48.5996Z",
    fill: "#CB002B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8084 23.8056C71.2804 30.3618 70.3747 41.7422 76.7784 49.2292C78.1939 50.8818 79.8472 52.2026 81.6434 53.1925L83.3595 50.5565C81.7961 49.7278 80.3579 48.6007 79.1365 47.1749C73.838 40.9852 74.5891 31.5767 80.8134 26.1548C86.2968 21.3776 94.2029 21.2967 99.6249 25.582L101.341 22.946C94.7934 17.9308 85.3701 18.0887 78.8084 23.8056Z",
    fill: "#F41154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.069 76.2598C122.79 77.3754 120.85 77.2458 119.759 75.9706L102.31 56.2157C102.02 55.876 102.06 55.3633 102.401 55.0669L105.824 52.0869C106.165 51.7904 106.674 51.8234 106.964 52.1631L124.413 71.918C125.504 73.1898 125.348 75.1442 124.069 76.2598Z",
    fill: "#841918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.09 27.2075C96.6007 20.7931 86.9204 20.1478 80.467 25.7652C74.0169 31.3819 73.2391 41.1368 78.7287 47.5546C84.2183 53.9723 93.8979 54.6143 100.351 48.9968C106.805 43.3794 107.583 33.6244 102.09 27.2075ZM100.001 48.5873C93.7763 54.0094 84.4393 53.386 79.1405 47.196C73.8417 41.0059 74.5929 31.5969 80.8174 26.1748C87.042 20.7527 96.379 21.376 101.678 27.5661C106.977 33.7561 106.226 43.1685 100.001 48.5873Z",
    fill: "#BF3936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4652 25.7452C74.0155 31.3616 73.2377 41.116 78.7271 47.5334C79.9822 49.0008 81.456 50.162 83.0611 51.0198L83.3626 50.5598C81.7991 49.731 80.3609 48.6039 79.1396 47.1782C73.8411 40.9885 74.5922 31.5799 80.8164 26.1581C86.2999 21.3809 94.206 21.3 99.6279 25.5853L99.9294 25.1252C94.3104 20.7128 86.1391 20.8065 80.4652 25.7452Z",
    fill: "#A02727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.495 28.8936L106.233 29.1182L107.844 31.0486L108.105 30.8241L106.495 28.8936Z",
    fill: "#FFF2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.231 26.9028L109.891 26.9421L110.163 29.3656L110.503 29.3263L110.231 26.9028Z",
    fill: "#FFF2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.313 29.8243L115.773 30.6672L115.936 30.9732L117.476 30.1302L117.313 29.8243Z",
    fill: "#FFF2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1652 50.7841L53.1463 48.8782C53.0724 41.8688 61.9077 41.5113 61.8455 35.8399C61.8124 33.1556 59.8199 31.4328 56.8225 31.4583C53.6724 31.4958 51.6603 33.4243 51.6934 36.1085L51.7063 36.9879C51.7093 37.5012 51.4083 37.8184 50.8984 37.7669L46.6311 37.6082C46.122 37.5658 45.8186 37.2596 45.8142 36.8473L45.8084 36.1783C45.7405 30.1955 50.2688 26.0786 56.9213 26.0033C63.4743 25.9267 67.7773 29.7507 67.8423 35.5779C67.9302 44.191 58.9925 44.3914 59.0509 49.1829L59.0696 50.7312C59.0726 51.2445 58.7716 51.5617 58.2659 51.5648L53.9967 51.6172C53.4806 51.6029 53.1682 51.2974 53.1652 50.7841ZM52.6436 58.9868C52.6218 56.9252 54.3287 55.2591 56.4675 55.228C58.4984 55.2054 60.3479 56.8295 60.3696 58.891C60.3914 60.9526 58.5857 62.6265 56.5002 62.6442C54.3524 62.676 52.6653 61.0484 52.6436 58.9868Z",
    fill: "#CB002B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11485_49982",
    x: 28.1709,
    y: 15.563,
    width: 60.6737,
    height: 84.5083,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.1102,
    dy: -1.26612
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11485_49982"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11485_49982",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11485_49982",
    x1: 75.4947,
    y1: 0.744141,
    x2: 75.4947,
    y2: 108.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11485_49982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 109,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11485_49982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 108.807,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/NoData.ce13f68b.svg";
export { ForwardRef as ReactComponent };